module.exports = __webpack_public_path__ + "img/group.8796f157.svg";